<template>
  <page>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :footer-props="{'items-per-page-options': itemsPerPage }"
        v-bind:options.sync="pagination"
        item-key="name"
        :loading="loading"
        :no-data-text="noDataText"
        :custom-filter="customSearch"
      >
        <template v-slot:item="row"
          ><tr>
            <td>{{ convertDocType(row.item.docType) }}</td>
            <td class="text-xs-left">{{ row.item.formId }}</td>
            <td class="text-xs-left">{{ checkEmpty(row.item.keyFact1) }}</td>
            <td class="text-xs-left">{{ checkEmpty(row.item.keyFact2) }}</td>
            <td class="text-xs-left">{{ checkEmpty(row.item.keyFact3) }}</td>
            <td class="text-xs-left">{{ checkEmpty(row.item.keyFact4) }}</td>
            <td class="text-xs-left">{{ checkEmpty(row.item.keyFact5) }}</td>
            <td class="text-xs-left">{{ checkEmpty(row.item.keyFact6) }}</td>
            <td class="text-xs-left">{{ checkEmpty(row.item.nxtSeqNo) }}</td>
            <td class="table-action-header">
              <table-action
                :rowData="row"
                review
                @review="doAction('edit', row.item)"
                query
                @query="doAction('query', row.item)"
                remove
                @remove="doPromptRemove"
              ></table-action>
            </td></tr
        ></template>
      </v-data-table>
    </v-card>
    <confirm v-model="promptRemove" @ok="doRemove">Please confirm deletion of this records.</confirm>
    <v-dialog v-model="docNoSeqReview" width="1100px" persistent>
      <docno-seq-review :docNoSeqForm="docNoSeqForm" :mode="mode" @close="doClose"></docno-seq-review>
    </v-dialog>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import DocnoSeqReview from './DocNoSeqReview'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Clause',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'clause' }
        },
        {
          text: 'Default Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'defText' }
        },
        {
          text: 'Document Heading Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docHdgTxtList' }
        },
        {
          text: 'Document No. Format',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docNoForm' }
        },
        {
          text: 'Standard Risk Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'stdRiskTxtList' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Doc Type', align: 'left', value: 'docType' },
        { text: 'Format ID', value: 'formId' },
        { text: 'Factor 1', value: 'keyFact1' },
        { text: 'Factor 2', value: 'keyFact2' },
        { text: 'Factor 3', value: 'keyFact3' },
        { text: 'Factor 4', value: 'keyFact4' },
        { text: 'Factor 5', value: 'keyFact5' },
        { text: 'Factor 6', value: 'keyFact6' },
        { text: 'Next Seq No.', value: 'nxtSeqNo' },
        TableConst.tableActionHeader
      ],
      docNoSeqForm: {
        docType: null,
        formId: null,
        keyFact1: null,
        keyFact2: null,
        keyFact3: null,
        keyFact4: null,
        keyFact5: null,
        keyFact6: null,
        nxtSeqNo: null,
        createdName: '',
        createdDate: null,
        modifiedName: '',
        modifiedDate: null
      },
      mode: '',
      totalItems: 0,
      newDocNoSeq: false,
      docNoSeqReview: false,
      selectedDocNoSeq: {},
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.docFormatParam.menu
    },
    docTypeList() {
      return [
        { label: 'C - Claim No.', value: 'C' },
        { label: 'P - Policy No.', value: 'P' },
        { label: 'V - Voyage No.', value: 'V' },
        { label: 'H - Vessel No.', value: 'H' }
      ]
    },
    formIdList() {
      return [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
        { label: '07', value: 7 },
        { label: '08', value: 8 },
        { label: '09', value: 9 },
        { label: '10', value: 10 }
      ]
    },
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find((a) => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.getDocNoSeqList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          this.items = []
          const { data } = result.data
          if (data) {
            data.map((docNoSeq) => {
              const convertList = {
                docType: docNoSeq.docType,
                formId: docNoSeq.formId,
                keyFact1: docNoSeq.keyFact1,
                keyFact2: docNoSeq.keyFact2,
                keyFact3: docNoSeq.keyFact3,
                keyFact4: docNoSeq.keyFact4,
                keyFact5: docNoSeq.keyFact5,
                keyFact6: docNoSeq.keyFact6,
                nxtSeqNo: docNoSeq.nxtSeqNo
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    convertDocType(field) {
      if (field === 'P') {
        return 'Policy No.'
      } else if (field === 'C') {
        return 'Claims No.'
      } else if (field === 'V') {
        return 'Voyage No.'
      } else {
        return 'Vessel No.'
      }
    },
    checkEmpty(field) {
      if (field === '') {
        return '-'
      } else {
        return field
      }
    },
    async doAction(mode, listData) {
      this.resetMessages()
      const apiURI = this.menu.getDocNoSeq
      const expand = {
        docType: listData.docType,
        formId: listData.formId,
        keyFact1: listData.keyFact1,
        keyFact2: listData.keyFact2,
        keyFact3: listData.keyFact3,
        keyFact4: listData.keyFact4,
        keyFact5: listData.keyFact5,
        keyFact6: listData.keyFact6
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.docNoSeqForm.docType = data.docNoSeq.docType
          this.docNoSeqForm.formId = data.docNoSeq.formId
          this.docNoSeqForm.keyFact1 = data.docNoSeq.keyFact1
          this.docNoSeqForm.keyFact2 = data.docNoSeq.keyFact2
          this.docNoSeqForm.keyFact3 = data.docNoSeq.keyFact3
          this.docNoSeqForm.keyFact4 = data.docNoSeq.keyFact4
          this.docNoSeqForm.keyFact5 = data.docNoSeq.keyFact5
          this.docNoSeqForm.keyFact6 = data.docNoSeq.keyFact6
          this.docNoSeqForm.nxtSeqNo = data.docNoSeq.nxtSeqNo
          this.docNoSeqForm.createdName = data.docNoSeq.createdName
          this.docNoSeqForm.createdDate = data.docNoSeq.createdDate
          this.docNoSeqForm.modifiedName = data.docNoSeq.modifiedName
          this.docNoSeqForm.modifiedDate = data.docNoSeq.modifiedDate

          this.mode = mode
          this.docNoSeqReview = true
        }
      }
    },
    doClose() {
      this.docNoSeqReview = false
      this.doInit(false)
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedDocNoSeq = data.item
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.menu.deleteDocNoSeq
      if (apiURI) {
        const expand = this.selectedDocNoSeq
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  mounted() {
    this.doInit(true)
  },
  components: {
    DocnoSeqReview
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
